
// ux_04_014
import '@/assets/scss/index.scss'
import { pdMixin } from '@/mixin/pd/pdMixin'
import PdUnitCmp from '@/components/pd/common/PdUnitCmp.vue'
import { convertCdnResizeUrl, errorPrfImg, convertPrfResizeUrl, isNotEmpty, unescape } from '@/utils'
import CommonImage from '~/components/common/CommonImage.vue'
import { getCapturedImageUrl, getResizedImgUrl } from '~/scriptData/common/interM2'
import CommonVideo from '~/components/common/CommonVideo.vue'

export default {
  components: {
    CommonVideo,
    CommonImage,
    PdUnitCmp
  },
  mixins: [pdMixin],
  props: {
    revwCttsList: {
      type: Array,
      default: () => {
        return []
      }
    },
    totalCnt: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      visible: false,
      data: {}, // 부모창에서 가져온 데이터
      revwDtl: {}, // 리뷰 상세 정보
      attrList: [], // 속성 항목 리스트
      cttsList: [], // 리뷰 컨텐츠 리스트
      viewImg: {}, // 뷰 이미지
      revwPdInfo: {}, // 상품정보
      rcmYn: 'N', // 추천 여부
      rcmCnt: 0, // 추천 건수
      revwCttsSwiperOpt: { // 리뷰 스와이퍼 옵션
        slidesPerView: 'auto',
        lazy: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      revwMngNo: 0
    }
  },
  computed: {
    showPrevArrow () {
      const revwIdx = this.revwCttsList.findIndex(item => Number(item.revwMngNo) === this.revwMngNo)
      return revwIdx !== 0
    },
    showNextArrow () {
      const revwIdx = this.revwCttsList.findIndex(item => Number(item.revwMngNo) === this.revwMngNo)
      return this.revwCttsList.length !== revwIdx + 1
    },
  },
  watch: {
    visible (flag) {
      if (flag) {
        this.selRevwDtl(this.data.revwMngNo)
      } else {
        // 초기화
        this.initData()
      }
    }
  },
  mounted () {
  },
  methods: {
    getCapturedImageUrl,
    getResizedImgUrl,

    close () {
      // 팝업 닫기
      this.visible = false
    },
    convertCdnResizeUrl (url, resize) {
      return convertCdnResizeUrl(url, resize)
    },
    errorPrfImg (e) {
      return errorPrfImg(e)
    },
    convertPrfResizeUrl (url, resize) {
      return convertPrfResizeUrl(url, resize)
    },
    isNotEmpty (obj) {
      return isNotEmpty(obj)
    },
    unescape (str) {
      return unescape(str)
    },

    async selRevwDtl (revwMngNo) {
      this.initData()
      this.revwMngNo = revwMngNo
      const revwIdx = this.revwCttsList.findIndex(item => Number(item.revwMngNo) === this.revwMngNo)
      if (this.revwCttsList.length - 1 === revwIdx && this.revwCttsList.length !== this.totalCnt) {
        this.$emit('selRevwCttsReload')
      }
      await this.$AxiosBuilder
        .data({ revwMngNo })
        .build()
        .post('/pd/pds/revw/selRevwDtl')
        .then((res) => {
          if (res.data.success) {
            const result = res.data.data
            const revwDtl = result.revwDtl

            // todo: best 여부, 알람 여부 가져올 수 없음
            this.revwPdInfo = { best: false, pdAnc: false, ...result.pdData[0] } // 리뷰 상품정보
            this.revwPdInfo.optCn = '' // 컴포넌트 옵션정보 전달 안함. 따로노출
            this.revwPdInfo.soldout = this.revwPdInfo.stckQy <= 0 // 재고가 0 이하일 때 품절
            this.revwPdInfo.optPdYn = result.pdData[0].optPdYn === 'Y' // 옵션 여부 추가

            // 전용상품인 경우, 전용품번 셋팅
            if (this.data.isGrpPd) {
              this.revwPdInfo.grpPdNo = this.data.grpPdNo
              this.revwPdInfo.isBoxPd = this.data.isBoxPd
            }

            this.revwDtl = revwDtl
            this.attrList = revwDtl.attrs // 리뷰 속성 항목 리스트

            revwDtl.ctts.forEach((item, idx) => {
              let videoOpt = {}
              if (item.pdCttsTy === '02' && this.isNotEmpty(item.imgUrl)) { // 동영상이고 url이 있을 때 비디오 옵션 추가
                videoOpt = { // video 기본 옵션 설정
                  controls: false, // 컨트롤 바 노출 여부
                  autoplay: true, // 자동재생
                  muted: true, // 음소거
                  loop: false, // 반복재생
                  preload: 'auto', // 즉시 비디오 데이터를 다운로드 시작할지 여부 결정
                  poster: '', // 썸네일 이미지
                  playbackRates: [1], // 배속
                }
              }
              const obj = {
                id: 'revwDtl' + String(idx),
                pdCttsTy: item.pdCttsTy, // 컨텐츠 유형 (01: 이미지, 02: 동영상)
                imgUrl: item.imgUrl, // url
                videoOpt
              }
              this.cttsList.push(obj)
              // 첫 컨텐츠 메인으로 노출
              if (idx === 0) { this.viewImg = obj }
            })
          }
        }).catch((e) => {
          console.log('LayerRevwDtl watch error : ', e)
        })
    },

    tglRevwRcm () {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
      } else {
        this.$AxiosBuilder
          .data({ revwMngNo: this.revwMngNo })
          .build()
          .post('/pd/pds/revw/tglRevwRcm')
          .then((res) => {
            if (res.data.success) {
              const rcmFlag = res.data.extraData.rcmYn
              this.$set(this.revwDtl, 'rcmCont', rcmFlag ? this.revwDtl.rcmCont + 1 : this.revwDtl.rcmCont - 1)
              this.$set(this.revwDtl, 'rcmYn', rcmFlag ? 'Y' : 'N')
            } else {
              this.$alert(res.data.message)
            }
          }).catch((e) => {
            console.log('LayerRevwDtl tglRevwRcm error : ', e)
          })
      }
      // 리뷰 추천 토글
    },

    muted (val) { // 음소거
      if (Array.isArray(this.$refs[`video${val.id}`])) {
        console.log('음소거', 'component:', this.$refs[`video${val.id}`][0])
        this.$refs[`video${val.id}`][0].player.muted(val.checked)
      } else {
        console.log('음소거', 'component:', this.$refs[`video${val.id}`])
        this.$refs[`video${val.id}`].player.muted(val.checked)
      }
    },

    fullScreen (val) { // 전체보기
      if (Array.isArray(this.$refs[`video${val.id}`])) {
        console.log('전체보기', 'component:', this.$refs[`video${val.id}`][0])
        this.$refs[`video${val.id}`][0].player.requestFullscreen()
      } else {
        console.log('전체보기', 'component:', this.$refs[`video${val.id}`])
        this.$refs[`video${val.id}`].player.requestFullscreen()
      }
    },

    async clickPrev () {
      const revwIdx = this.revwCttsList.findIndex(item => Number(item.revwMngNo) === this.revwMngNo)
      if (revwIdx - 1 >= 0) {
        const prevRevwMngNo = Number(this.revwCttsList[revwIdx - 1].revwMngNo)
        await this.selRevwDtl(prevRevwMngNo)
      }
    },

    async clickNext () {
      const revwIdx = this.revwCttsList.findIndex(item => Number(item.revwMngNo) === this.revwMngNo)
      if (revwIdx + 1 < this.totalCnt) {
        const nextRevwMngNo = Number(this.revwCttsList[revwIdx + 1].revwMngNo)
        await this.selRevwDtl(nextRevwMngNo)
      }
    },

    initData () { // 초기화
      this.revwPdInfo = {} // 리뷰작성 상품
      this.viewImg = {} // 리뷰 이미지 뷰 영역
      this.revwDtl = {} // 리뷰 상세
      this.attrList = [] // 리뷰 속성
      this.cttsList = [] // 리뷰 컨텐츠
      this.rcmCnt = 0 // 추천건수
      this.rcmYn = 'N' // 추천여부
    },
    clickReview (ctts) {
      this.viewImg = ctts
    }
  }
}
